import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Wrapper from './wrapper'
import ContactInviteCombo from '../../components/ContactInviteCombo'
import Slider from 'react-slick'
import { adAccounts } from '../../api'

const ACCOUNTS_SLIDE_SIZE = 10

const chunkAccounts = (accounts, batchSize = 10) => {
	let accountChunks = []
	for(var i = 0; i < accounts.length; i+= batchSize) {
		accountChunks.push(accounts.slice(i, i+batchSize))
	}
	return accountChunks
}

export default class AccountSelector extends Component {
	constructor(props) {
		super(props)
		this.fetchAdAccounts = this.fetchAdAccounts.bind(this)
		this.adAccountSelected = this.adAccountSelected.bind(this)
	}

	fetchAdAccounts = async () => {
		const data = await adAccounts(this.props.facebookSession.accessToken, this.props.sessionEmail)
		if(data.status === 'FAIL') {
			window.mixpanel.track('[AdScore] - Front End Error', {
				email: this.props.sessionEmail,
				page: '/adaccounts'
			})
		}
		if(data.shape) {
			if(window.fbq) {
				window.fbq('trackCustom', 'admAuth', {shape: data.shape})
			}
			if(window.mixpanel) {
				window.mixpanel.people.set({
					shape: data.shape,
					numAccounts: data.accounts ? data.accounts.length : 0
				})
				window.mixpanel.track('[AdScore] - Accounts Loaded', {shape: data.shape})
			}
		}
		this.props.facebookAdAccountsSet(data.accounts)
	}

	componentDidMount() {
		// Verify they are logged in
		if(!this.props.sessionEmail) {
			// Redirect them to the homepage
			this.props.history.push('/')
		} else if(!this.props.facebookSessionValid()) {
			this.props.history.push('/login')
		} else {
			// Load the ad accounts if we don't have them
			if(!this.props.adAccounts) {
				this.fetchAdAccounts()
			}
		}
	}

	adAccountSelected = (acct) => {
		if(!this.props.facebookSessionValid()) {
			this.props.history.push('login')
		} else {
			window.mixpanel.track('[AdScore] - Ad Account Selected', {
				adAccountId: acct.id
			})
			this.props.facebookAdAccountSelected(acct)
			// Perform a request to the API and update the results
			this.props.history.push('/report/'+ acct.id)
		}
	}

	renderAdAccountList = () => {
		const chunks = chunkAccounts(this.props.adAccounts, ACCOUNTS_SLIDE_SIZE)
		var settings = {
			dots: true,
			infinite: false,
			speed: 0,
			slidesToShow: 1,
			slidesToScroll: 1
		}
		if(this.props.adAccounts.length > 0) {
			return (
				<Slider {...settings}>
					{chunks.map((accounts, chunkIdx) =>
						<div key={chunkIdx}>
							<ul className="select-container">
								{accounts.map((acct, idx) =>
									<li className="clearfix" key={idx}>
										<span>{acct.name}</span>
										<button className="cta" onClick={() => this.adAccountSelected(acct)}>
											Analyze Now
										</button>
									</li>
								)}
							</ul>
						</div>
					)}
				</Slider>
			)
		} else {
			return (
				<div className='no_accounts'>
					<p>We couldn&apos;t find any ad accounts for you. If you know that you have ad accounts and they didn&apos;t show up, please <a href='/'>start over</a>.</p>
					<p>If you don&apos;t have access to your ad accounts, click the link below!</p>
				</div>
			)
		}
	}

	renderError = () => {
		if(/accounts\/err/.test(window.location.hash)) {
			return (
				<div className='error'>
					<p>We couldn&apos;t load your report. Please try again!</p>
				</div>
			)
		} else {
			return (<span></span>)
		}
	}

	render() {
		if(this.props.adAccounts) {
			// If we have 
			return (
				<Wrapper>
					<ContactInviteCombo sessionEmail={this.props.sessionEmail}>
						<div className="action-container">
							{this.renderError()}
							<h2>Which Facebook ad account would you like to score?</h2>
							{this.renderAdAccountList()}
						</div>
					</ContactInviteCombo>
				</Wrapper>
			)
		} else {
			return(
				<Wrapper>
					<div className="action-container">
						<img src="https://www.datocms-assets.com/3323/1528916192-unified-box.png" alt="" className="loader" />
						<p>Loading your ad accounts</p>
					</div>
				</Wrapper>
			)
		}
		
	}
}

AccountSelector.propTypes = {
	facebookSession: PropTypes.object,
	adAccounts: PropTypes.array,
	facebookAdAccountsSet: PropTypes.func,
	history: PropTypes.object,
	facebookAdAccountSelected: PropTypes.func,
	sessionEmail: PropTypes.string,
	facebookSessionValid: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/containers/AccountSelector/index.js